import apiClient from 'apiClient';
import { AxiosPromise } from 'axios';
import { Task, TaskId, TaskStatus } from './Task';

const switchStatus = (apiPrefix: string, id: TaskId, newStatus: TaskStatus): AxiosPromise<Task[]> => {
  return apiClient.patch(`${apiPrefix}/tasks/${id}`, {
    status: newStatus,
  });
};

export default switchStatus;
